import GeoBookmark from 'ol-ext/control/GeoBookmark'
import { convertCoordinates } from '../tools/mapviewer-services'

class CustomGeoBookmark extends GeoBookmark {
  constructor (options) {
    if (!options) options = {}

    super(options)
    this.viewer = options.viewer || null
  }

  setBookmarks (bmark) {
    if (!bmark) {
      bmark = {}
      try {
        bmark = JSON.parse(localStorage[this.get('namespace') + '@bookmark'] || '{}')
      } catch (e) { console.warn('Failed to access localStorage...') }
    }
    const modify = this.get('editable')
    const ul = this.element.querySelector('ul')
    const self = this

    ul.innerHTML = ''
    for (const b in bmark) {
      const li = document.createElement('li')
      li.textContent = b
      li.setAttribute('data-bookmark', JSON.stringify(bmark[b]))
      li.setAttribute('data-name', b)
      li.addEventListener('click', function (e) {
        const bm = JSON.parse(e.target.getAttribute('data-bookmark'))
        const coord = bm.projection ? convertCoordinates(bm.pos, bm.projection, this.viewer.getViewProjection()) : bm.pos

        this.getMap().getView().animate({
          center: coord,
          zoom: bm.zoom,
          rotation: bm.rot || 0,
          // duration: 350,
        })
        this.element.classList.add('ol-collapsed')
        this.dispatchEvent({ type: 'select', name: e.target.getAttribute('data-name'), bookmark: bm })
      }.bind(this))
      ul.appendChild(li)
      if (modify && !bmark[b].permanent) {
        const button = document.createElement('button')
        button.setAttribute('data-name', b)
        button.setAttribute('type', 'button')
        button.setAttribute('title', this.get('deleteTitle') || 'Suppr.')
        button.addEventListener('click', function (e) {
          self.removeBookmark(this.getAttribute('data-name'))
          self.dispatchEvent({ type: 'remove', name: this.getAttribute('data-name') })
          e.stopPropagation()
        })
        li.appendChild(button)
      }
    }
    try {
      localStorage[this.get('namespace') + '@bookmark'] = JSON.stringify(bmark)
    } catch (e) { console.warn('Failed to access localStorage...') }
  }

  addBookmark (name, position, zoom, permanent) {
    if (!name) { return }
    const options = position
    let rot
    if (options && options.position) {
      zoom = options.zoom
      permanent = options.permanent
      rot = options.rotation
      position = options.position
    } else {
      rot = this.getMap().getView().getRotation()
    }
    const bmark = this.getBookmarks()
    // Don't override permanent bookmark
    if (bmark[name] && bmark[name].permanent) { return }
    // Create or override
    bmark[name] = {
      pos: position || this.getMap().getView().getCenter(),
      zoom: zoom || this.getMap().getView().getZoom(),
      permanent: !!permanent,
      projection: this.viewer.getViewProjection(),
    }
    if (rot) {
      bmark[name].rot = rot
    }
    this.setBookmarks(bmark)
  }
}

export default CustomGeoBookmark
